import React from "react";
import {
  Stack,
  Calendar,
  Fabric,
  DetailsListLayoutMode,
  SelectionMode,
  IGroup,
  IDetailsHeaderProps,
  IRenderFunction,
  DetailsHeader,
  IColumn,
  ShimmeredDetailsList,
  IListProps,
  PrimaryButton,
  Callout,
  IPersonaProps,
  DayOfWeek,
  DefaultButton,
  DirectionalHint,
  FocusTrapZone,
  Text,
} from "office-ui-fabric-react";
import { childrenGap, API_URL, DayPickerStrings } from "../../common/Constants";
import { useParams } from "react-router-dom";
import { ISearchTransactions, IAccessVM } from "../../../vm";
import { getAccessLogsConfiguration, getCustomerTransaction } from "../../../services/customers/CustomerService";
import moment from "moment";
import { ToastContext } from "../../common/ToastProvider";
import { getToken } from "../../../services/UtilService";
import { Loading } from "../../../services/Loading";

export interface AccessTransactionProps {
  customerName: string;
}

let calendarButtonElement: HTMLElement;

// const DayPickerString = {
//   months: [
//     "January",
//     "February",
//     "March",
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December",
//   ],
//   shortMonths: [
//     "Jan",
//     "Feb",
//     "Mar",
//     "Apr",
//     "May",
//     "Jun",
//     "Jul",
//     "Aug",
//     "Sep",
//     "Oct",
//     "Nov",
//     "Dec",
//   ],
//   days: [
//     "Sunday",
//     "Monday",
//     "Tuesday",
//     "Wednesday",
//     "Thursday",
//     "Friday",
//     "Saturday",
//   ],
//   shortDays: ["S", "M", "T", "W", "T", "F", "S"],
//   goToToday: "Go to today",
//   weekNumberFormatString: "Week number {0}",
//   prevMonthAriaLabel: "Previous month",
//   nextMonthAriaLabel: "Next month",
//   prevYearAriaLabel: "Previous year",
//   nextYearAriaLabel: "Next year",
//   prevYearRangeAriaLabel: "Previous year range",
//   nextYearRangeAriaLabel: "Next year range",
//   closeButtonAriaLabel: "Close",
//   monthPickerHeaderAriaLabel: "{0}, select to change the year",
//   yearPickerHeaderAriaLabel: "{0}, select to change the month",
// };

const AccessTransaction: React.FC<AccessTransactionProps> = ({
  customerName
}) => {
  //hooks
  const params: any = useParams();
  const { showToast } = React.useContext(ToastContext);

  //state
  const [state, setState] = React.useState({
    isLoading: false,
    isTransactionFound: false,
    // date: new Date(),
    date: undefined,
    showCallender: false,
    searchObj: {
      customerId: params.customerId,
      startDate: new Date(),
      endDate: new Date(),
    },
    transactions: [],
    group: [],
    cardHoldersList: [],
    cardHolderIds: [],
  } as {
    isLoading: boolean;
    isTransactionFound: boolean;
    date?: Date;
    showCallender: boolean;
    searchObj: ISearchTransactions;
    transactions: any[];
    group: IGroup[];
    cardHoldersList: IPersonaProps[];
    cardHolderIds: [];
  });
  const [dateFormat, setDateFormat] = React.useState("MM/DD/YYYY hh:mm:ss A" as string);

  React.useEffect(() => {
    const asyncFunc = () => {
      // getCustomersAllTransaction();
      // getAllCardHolders();
    };
    asyncFunc();
  }, []);

  // const iconProps = { iconName: "Calendar" };

  const getCustomersAllTransaction = async (serchObj?: any) => {
    setState({ ...state, isLoading: true });
    let tempSearch = { ...state.searchObj };
    if (serchObj) {
      tempSearch = { ...tempSearch, ...serchObj };
    }

    tempSearch.startDate = moment(tempSearch.startDate)
      .startOf("month")
      .format("YYYY-MM-DD");
    // .toDate();
    tempSearch.endDate = moment(tempSearch.endDate)
      .endOf("month")
      .format("YYYY-MM-DD");
    // .toDate();

    let result = await getCustomerTransaction(tempSearch);
    // get date format
    let dateFormatResp = await getAccessLogsConfiguration({
      customerId: params.customerId,
    });
    if (result?.success) {
      // set date format
      if (dateFormatResp?.success && dateFormatResp.data.length > 0) {
          setDateFormat(dateFormatResp.data[0].dateFormat)
        } else {
          setDateFormat("MM/DD/YYYY hh:mm:ss A")
        }
      let group: IGroup[] = [];
      let transactions: any[] = [];
      // console.log(result.data);
      let startIndex = 0;
      result.data.accessReport.map((item: any) => {
        // item.eventSource.map((ele: IEventSource) => {
        //   group.push({
        //     key: ele._id as string,
        //     name: ele.name,
        //     startIndex: 0,
        //     count: 300,
        //   }); 100,   A   B     C
        // });

        group.push({
          key: item.eventSource._id,
          name: "Event Source: " + item.eventSource.name,
          startIndex: startIndex,
          count: item.data.length,
        });
        startIndex += item.data.length;

        item.data.map((ele: IAccessVM) => {
          transactions.push({
            id: ele._id,
            occurrenceTime: ele.occurrenceTime,
            eventType: ele.eventType,
            // eventType: ele.eventType.displayName,
            description: item.eventSource.description,
            cardHolderName:
              result.data.cardHolderDict[ele.cardHolderId].firstName +
              " " +
              result.data.cardHolderDict[ele.cardHolderId].lastName,
            cardNumber: result.data.cardHolderDict[ele.cardHolderId].cardNumber,
          });
        });
      });

      setState({
        ...state,
        transactions,
        group,
        isTransactionFound: true,
        isLoading: false,
        cardHolderIds: [],
      });
    } else {
      setState({ ...state, isLoading: false });
    }
  };

  // const getAllCardHolders = async () => {
  //   setState({ ...state, isLoading: true });
  //   let result = await getCardHolders({ customerId: params.customerId });
  //   if (result?.success) {
  //     let cardHoldersList: IPersonaProps[] = [];
  //     result.data.forEach((item) => {
  //       cardHoldersList.push({
  //         text: item.firstName + " " + item.lastName,
  //         id: item._id,
  //       });
  //     });
  //     setState({
  //       ...state,
  //       cardHoldersList,
  //     });
  //   } else {
  //     setState({ ...state, isLoading: false });
  //     //toast
  //   }
  // };

  const _onRenderDetailsHeader = (
    props: IDetailsHeaderProps,
    _defaultRender?: IRenderFunction<IDetailsHeaderProps>
  ) => {
    return (
      <DetailsHeader
        {...props}
        ariaLabelForToggleAllGroupsButton={"Expand collapse groups"}
      />
    );
  };

  const _renderItemColumn = (item: any, index: number, column: IColumn) => {
    switch (column.key) {
      case "occurrenceTime":
        return (
          <Text style={{ fontWeight: 600 }}>
            {/* {moment(item.occurrenceTime).format("M/D/YYYY hh:mm:ss A")} */}
            {moment(item.occurrenceTime).format(dateFormat)}
          </Text>
        );
      case "eventType":
        return <span>{item.eventType ? item.eventType : "NA"}</span>;
      default:
        return <span>{column.fieldName ? item[column.fieldName] : ""}</span>;
    }
  };

  // const shimmeredDetailsListProps: IListProps = {
  //   renderedWindowsAhead: 0,
  //   renderedWindowsBehind: 0,
  // };

  // const pickerSuggestionsProps: IBasePickerSuggestionsProps = {
  //   // suggestionsHeaderText: "Suggested Card holders",
  //   noResultsFoundText: "No Card holder found",
  // };

  // const onFilterChanged = async (
  //   filterText: string,
  //   PersonaList: IPersonaProps[]
  // ) => {
  //   if (state.cardHolderIds !== []) {
  //     await getCustomersAllTransaction({
  //       customerId: params.customerId,
  //       cardHolderIds: state.cardHolderIds,
  //     });
  //   }

  //   return filterText
  //     ? state.cardHoldersList !== undefined && state.cardHoldersList.filter(
  //         (persona) =>
  //           persona.text.toLowerCase().indexOf(filterText.toLowerCase()) ===
  //             0 && !listContainsTagList(persona, PersonaList)
  //       )
  //     : [];
  // };

  // const showAllTags = (selectedItems?: IPersonaProps[] | undefined) => {
  //   return removeDuplicates(state.cardHoldersList, selectedItems);
  // };

  // function removeDuplicates(
  //   personaList: IPersonaProps[],
  //   personas?: IPersonaProps[]
  // ) {
  //   return personaList.filter(
  //     (persona) => !listContainsTagList(persona, personas)
  //   );
  // }

  // const listContainsTagList = (
  //   persona: IPersonaProps,
  //   personaList?: IPersonaProps[]
  // ) => {
  //   if (!personaList || !personaList.length || personaList.length === 0) {
  //     return false;
  //   }
  //   return personaList.some((compareTag) => compareTag.id === persona.id);
  // };

  const onSearch = async () => {
    if (!state.date) {
      showToast("Please select a date before searching", "error");
    }

    getCustomersAllTransaction();
  };

  const downloadAccessReportPdf = async () => {
    let result = await fetch(
      `${API_URL}access-reports?customerId=${
        state.searchObj.customerId
      }&startDate=${moment(state.searchObj.startDate)
        .startOf("month")
        .format("YYYY-MM-DD")}&endDate=${moment(state.searchObj.endDate)
        .endOf("month")
        .format("YYYY-MM-DD")}`,
      {
        method: "GET",
        credentials: 'include', // Enable credentials for CORS
        headers: {
          at: getToken(),
        },
      }
    );
    let pdf = await result.blob();
    const pdfFile = await new Blob([pdf], { type: "application/pdf" });
    const pdfFileURL = await URL.createObjectURL(pdfFile);
    var a: any = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display:none";
    a.href = pdfFileURL;
    a.download = `${customerName} Monthly Access Report.pdf`;
    a.click();
  };

  const closeCallender = (ev?: any) => {
    setState({
      ...state,
      showCallender: false,
    });
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      {/* <Stack
        horizontal
        wrap
        tokens={childrenGap}
        horizontalAlign="start"
        className="pt-8"
      >
        <Stack.Item>
          <TextField
            id="monthPicker"
            placeholder="Select a month"
            iconProps={iconProps}
            onClick={toggleIsCalloutVisible}
          />
          {isCalloutVisible && (
            <Callout
              ariaLabelledBy="calender"
              role="alertdialog"
              gapSpace={0}
              target={"#monthPicker"}
              onDismiss={toggleIsCalloutVisible}
            >
              <Calendar
                id={"calender"}
                showGoToToday={false}
                highlightCurrentMonth={true}
                highlightSelectedMonth={true}
                isDayPickerVisible={false}
                showMonthPickerAsOverlay={true}
                
              />
              <div id={"calender"}>a</div>
            </Callout>
          )}
        </Stack.Item>
        <Stack.Item>
          <PrimaryButton text="Search" />
        </Stack.Item>
      </Stack> */}
      <Stack
        wrap
        horizontal
        tokens={childrenGap}
        horizontalAlign="space-between"
        className="pt-16"
      >
        <Stack.Item>
          <Stack wrap tokens={childrenGap} horizontal horizontalAlign="start">
            <Stack.Item>
              {/* <DatePicker
                firstDayOfWeek={DayOfWeek.Sunday}
                value={state.date}
                showGoToToday={false}
                showMonthPickerAsOverlay={true}
                onSelectDate={(date: Date | null | undefined) =>
                  setState({
                    ...state,
                    date: date as any,
                    searchObj: {
                      ...state.searchObj,
                      startDate: moment(date).startOf("month").toDate(),
                      endDate: moment(date).endOf("month").toDate(),
                    },
                  })
                }
                placeholder="Select a date..."
                ariaLabel="Select a date"
              /> */}
              <div
                ref={(calendarBtn) => (calendarButtonElement = calendarBtn!)}
              >
                <DefaultButton
                  text={
                    !state.date
                      ? "Select a month"
                      : moment(state.date).format("MMM-YYYY")
                  }
                  onClick={() => setState({ ...state, showCallender: true })}
                  className="month-picker-btn"
                />
              </div>
              {state.showCallender && (
                <Callout
                  isBeakVisible={false}
                  // className="ms-DatePicker-callout"
                  gapSpace={0}
                  doNotLayer={false}
                  target={calendarButtonElement}
                  directionalHint={DirectionalHint.bottomLeftEdge}
                  onDismiss={() => closeCallender()}
                  setInitialFocus
                >
                  <FocusTrapZone
                    firstFocusableSelector="ms-DatePicker-day--today"
                    isClickableOutsideFocusTrap
                  >
                    <Calendar
                      // eslint-disable-next-line react/jsx-no-bind
                      onSelectDate={(date: Date | null | undefined) =>
                        setState({
                          ...state,
                          date: date as any,
                          searchObj: {
                            ...state.searchObj,
                            startDate: moment(date).startOf("month").toDate(),
                            endDate: moment(date).endOf("month").toDate(),
                          },
                          showCallender: false,
                        })
                      }
                      onDismiss={() => closeCallender()}
                      isMonthPickerVisible={true}
                      value={state.date}
                      firstDayOfWeek={DayOfWeek.Sunday}
                      strings={DayPickerStrings}
                      isDayPickerVisible={false}
                      highlightCurrentMonth={false}
                      highlightSelectedMonth={true}
                      showMonthPickerAsOverlay={false}
                      showGoToToday={false}
                    />
                  </FocusTrapZone>
                </Callout>
              )}
            </Stack.Item>
            <Stack.Item>
              <PrimaryButton text="Search" onClick={() => onSearch()} />
            </Stack.Item>
          </Stack>
        </Stack.Item>
        {/* <Stack.Item>
          <DefaultButton
            text="Download Report"
            disabled={
              state.isLoading === true || state.transactions.length === 0
            }
            onClick={() => downloadAccessReportPdf()}
            className="custom-secondary-btn"
          />
        </Stack.Item> */}
      </Stack>
      <br />
      <Stack>
        <Stack.Item>
          <PrimaryButton
            text="Download Report"
            disabled={
              state.isLoading === true || state.transactions.length === 0
            }
            onClick={() => downloadAccessReportPdf()}
            // className="custom-secondary-btn"
          />
        </Stack.Item>
      </Stack>
      <br />
      <Stack tokens={childrenGap}>
        {/* <Stack.Item>
          <Stack horizontal wrap horizontalAlign="end" tokens={childrenGap}>
            <Stack.Item>
              <NormalPeoplePicker
                inputProps={{
                  placeholder: "Search cardholders by name/cardnumber...",
                }}
                onResolveSuggestions={onFilterChanged as any}
                removeButtonAriaLabel="Remove"
                pickerSuggestionsProps={pickerSuggestionsProps}
                onEmptyResolveSuggestions={showAllTags}
                onChange={(items: any) => {
                  let cardHolderIds: any = [];
                  items.forEach((ele: any) => {
                    cardHolderIds.push(ele.id);
                    setState({ ...state, cardHolderIds });
                  });
                  // styles={{ root: { width: "300px" } }}
                }}
              />
            </Stack.Item>
          </Stack>
        </Stack.Item> */}
        <Stack.Item>
          <Fabric>
            <ShimmeredDetailsList
              items={state.transactions}
              groups={state.group}
              columns={[
                {
                  key: "occurrenceTime",
                  name: "Occurrence Time",
                  fieldName: "occurrenceTime",
                  minWidth: 200,
                  maxWidth: 300,
                  isResizable: true,
                },
                {
                  key: "description",
                  name: "Event Access Zone",
                  fieldName: "description",
                  minWidth: 200,
                  maxWidth: 400,
                  isResizable: true,
                },
                {
                  key: "eventType",
                  name: "Event Type",
                  fieldName: "eventType",
                  minWidth: 200,
                  maxWidth: 300,
                  isResizable: true,
                },
                {
                  key: "cardHolderName",
                  name: "Cardholder Name",
                  fieldName: "cardHolderName",
                  minWidth: 200,
                  maxWidth: 400,
                  isResizable: true,
                },
                {
                  key: "cardNumber",
                  name: "Card Number",
                  fieldName: "cardNumber",
                  minWidth: 200,
                  maxWidth: 300,
                  isResizable: true,
                },
              ]}
              onRenderItemColumn={_renderItemColumn as any}
              onRenderDetailsHeader={_onRenderDetailsHeader as any}
              // onShouldVirtualize={() => false}
              // enableShimmer={state.isLoading}
              compact={true}
              setKey="set"
              layoutMode={DetailsListLayoutMode.justified}
              selectionMode={SelectionMode.none}
              // listProps={shimmeredDetailsListProps}
            />
          </Fabric>
        </Stack.Item>
      </Stack>
    </React.Fragment>
  );
};

export default AccessTransaction;
